// extracted by mini-css-extract-plugin
export default {"root":"classes_root__9quYt","icon":"classes_icon__rZsjX"};